import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=1ba7dcdc&scoped=true&"
import script from "./SearchFilter.vue?vue&type=script&lang=js&"
export * from "./SearchFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=1ba7dcdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7dcdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChip,VCol})
